import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Statia from '../block/Statia'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Statia data={data} />
      </>
    )
  }
}

export default App